var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 34,
    fill: "#373A3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 595,
    height: 842,
    transform: "translate(-503 -800)",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 -8H-503V42H92V-8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.699219,
    width: 35.7,
    height: 34,
    rx: 17,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    transform: "translate(10.0469 8.5)",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.697 17.6002C22.0294 17.2678 22.0294 16.7306 21.697 16.3983C21.5313 16.2325 21.3137 16.1492 21.0961 16.1492C20.8785 16.1492 20.6609 16.2325 20.4951 16.3983L19.3961 17.4973V11.0492C19.3961 10.58 19.0161 10.1992 18.5461 10.1992C18.076 10.1992 17.6961 10.58 17.6961 11.0492V17.4973L16.597 16.3983C16.2647 16.0659 15.7275 16.0659 15.3951 16.3983C15.0628 16.7306 15.0628 17.2678 15.3951 17.6002L17.9451 20.1502C18.2775 20.4825 18.8147 20.4825 19.147 20.1502L21.697 17.6002Z",
    fill: "#032339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5961 22.0994C12.1267 22.0994 11.7461 22.48 11.7461 22.9494C11.7461 23.4189 12.1267 23.7994 12.5961 23.7994H24.4961C24.9655 23.7994 25.3461 23.4189 25.3461 22.9494C25.3461 22.48 24.9655 22.0994 24.4961 22.0994H12.5961Z",
    fill: "#032339"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 595,
    height: 842,
    fill: "white",
    transform: "translate(-503 -800)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBtn);
export default __webpack_public_path__ + "static/media/downloadBtn.9c76ca122f12835a9acd9ffeb20690fb.svg";
export { ForwardRef as ReactComponent };